import {MacOSCursor} from '@remotion/mac-cursors';
import {Video} from '@remotion/media';
import {
	AbsoluteFill,
	Easing,
	interpolate,
	useCurrentFrame,
	useVideoConfig,
} from 'remotion';
import {removeStudioLogoFocusRing} from './effects/remove-studio-logo-focus-ring';

export const ExploreStudioRecording20261027Composition = () => {
	const {fps} = useVideoConfig();
	const frame = (useCurrentFrame() * 60) / fps;

	return (
		<AbsoluteFill
			name="Canvas Capture"
			durationInFrames={(417 / 60) * fps}
			style={{
				width: 2330,
				height: 1440,
			}}
		>
			<Video
				src="https://remotion.media/explore-remotion/studio-source-2026-10-27-30dd4bd589df.mp4"
				durationInFrames={(417 / 60) * fps}
				muted
				effects={[removeStudioLogoFocusRing({})]}
				style={{
					position: 'absolute',
				}}
			/>
			<MacOSCursor
				cursor={interpolate(
					frame,
					[6, 33, 34, 35, 50, 51, 60, 61, 340, 344, 345, 352, 353],
					[
						'auto',
						'default',
						'auto',
						'default',
						'auto',
						'default',
						'auto',
						'default',
						'auto',
						'default',
						'auto',
						'custom',
						'auto',
					],
					{
						easing: Easing.step1,
						extrapolateLeft: 'clamp',
						extrapolateRight: 'clamp',
					},
				)}
				customCursor={
					'url("data:image/svg+xml,%3Csvg%20width%3D%2224%22%20height%3D%2224%22%20viewBox%3D%220%200%2064%2064%22%20fill%3D%22none%22%20xmlns%3D%22http%3A%2F%2Fwww.w3.org%2F2000%2Fsvg%22%3E%3Cstyle%3E%0A%3Awhere(%3Aroot)%20%7B%0A%20%20--remotion-studio-black%3A%20black%3B%0A%20%20--remotion-studio-white%3A%20white%3B%0A%20%20--remotion-studio-red%3A%20red%3B%0A%20%20--remotion-studio-transparent%3A%20transparent%3B%0A%20%20--remotion-studio-current-color%3A%20currentColor%3B%0A%20%20--remotion-studio-background%3A%20rgb(31%2C36%2C40)%3B%0A%20%20--remotion-studio-background-transparent%3A%20rgba(31%2C36%2C40%2C%200)%3B%0A%20%20--remotion-studio-input-background%3A%20%232f363d%3B%0A%20%20--remotion-studio-tab-hover-background%3A%20%23232629%3B%0A%20%20--remotion-studio-light-color%3A%20%23ddd%3B%0A%20%20--remotion-studio-light-text%3A%20%23A6A7A9%3B%0A%20%20--remotion-studio-ruler-color%3A%20%23808080%3B%0A%20%20--remotion-studio-white-alpha-05%3A%20rgba(255%2C%20255%2C%20255%2C%200.05)%3B%0A%20%20--remotion-studio-white-alpha-06%3A%20rgba(255%2C%20255%2C%20255%2C%200.06)%3B%0A%20%20--remotion-studio-white-alpha-08%3A%20rgba(255%2C%20255%2C%20255%2C%200.08)%3B%0A%20%20--remotion-studio-white-alpha-10%3A%20rgba(255%2C%20255%2C%20255%2C%200.1)%3B%0A%20%20--remotion-studio-white-alpha-12%3A%20rgba(255%2C%20255%2C%20255%2C%200.12)%3B%0A%20%20--remotion-studio-white-alpha-15%3A%20rgba(255%2C%20255%2C%20255%2C%200.15)%3B%0A%20%20--remotion-studio-white-alpha-20%3A%20rgba(255%2C%20255%2C%20255%2C%200.2)%3B%0A%20%20--remotion-studio-white-alpha-25%3A%20rgba(255%2C%20255%2C%20255%2C%200.25)%3B%0A%20%20--remotion-studio-white-alpha-30%3A%20rgba(255%2C%20255%2C%20255%2C%200.3)%3B%0A%20%20--remotion-studio-white-alpha-35%3A%20rgba(255%2C%20255%2C%20255%2C%200.35)%3B%0A%20%20--remotion-studio-white-alpha-40%3A%20rgba(255%2C%20255%2C%20255%2C%200.4)%3B%0A%20%20--remotion-studio-white-alpha-45%3A%20rgba(255%2C%20255%2C%20255%2C%200.45)%3B%0A%20%20--remotion-studio-white-alpha-50%3A%20rgba(255%2C%20255%2C%20255%2C%200.5)%3B%0A%20%20--remotion-studio-white-alpha-60%3A%20rgba(255%2C%20255%2C%20255%2C%200.6)%3B%0A%20%20--remotion-studio-white-alpha-70%3A%20rgba(255%2C%20255%2C%20255%2C%200.7)%3B%0A%20%20--remotion-studio-white-alpha-72%3A%20rgba(255%2C%20255%2C%20255%2C%200.72)%3B%0A%20%20--remotion-studio-white-alpha-80%3A%20rgba(255%2C%20255%2C%20255%2C%200.8)%3B%0A%20%20--remotion-studio-white-alpha-90%3A%20rgba(255%2C%20255%2C%20255%2C%200.9)%3B%0A%20%20--remotion-studio-black-alpha-28%3A%20rgba(0%2C%200%2C%200%2C%200.28)%3B%0A%20%20--remotion-studio-black-alpha-30%3A%20rgba(0%2C%200%2C%200%2C%200.3)%3B%0A%20%20--remotion-studio-black-alpha-40%3A%20rgba(0%2C%200%2C%200%2C%200.4)%3B%0A%20%20--remotion-studio-black-alpha-50%3A%20rgba(0%2C%200%2C%200%2C%200.5)%3B%0A%20%20--remotion-studio-black-alpha-60%3A%20rgba(0%2C%200%2C%200%2C%200.6)%3B%0A%20%20--remotion-studio-black-alpha-80%3A%20rgba(0%2C%200%2C%200%2C%200.8)%3B%0A%20%20--remotion-studio-black-alpha-85%3A%20rgba(0%2C%200%2C%200%2C%200.85)%3B%0A%20%20--remotion-studio-black-alpha-90%3A%20rgba(0%2C%200%2C%200%2C%200.9)%3B%0A%20%20--remotion-studio-fail-color%3A%20%23ff3232%3B%0A%20%20--remotion-studio-warning-color%3A%20%23f1c40f%3B%0A%20%20--remotion-studio-blue%3A%20%230b84f3%3B%0A%20%20--remotion-studio-blue-hovered%3A%20%234da3f7%3B%0A%20%20--remotion-studio-blue-disabled%3A%20%23284f73%3B%0A%20%20--remotion-studio-unselected-guide%3A%20%237e1219%3B%0A%20%20--remotion-studio-selected-guide%3A%20%23d22d3a%3B%0A%20%20--remotion-studio-line-color%3A%20%23363A3E%3B%0A%20%20--remotion-studio-timeline-track-separator%3A%20%2313161B%3B%0A%20%20--remotion-studio-light-gray%3A%20%23ccc%3B%0A%20%20--remotion-studio-keyboard-shortcut-key-color%3A%20%23eee%3B%0A%20%20--remotion-studio-notification-background%3A%20%23111111%3B%0A%20%20--remotion-studio-render-status-background%3A%20%23222%3B%0A%20%20--remotion-studio-error-code-frame-background%3A%20%23070707%3B%0A%20%20--remotion-studio-error-code-frame-line-background%3A%20%23121212%3B%0A%20%20--remotion-studio-error-link-color%3A%20%2358a6ff%3B%0A%20%20--remotion-studio-info-blue%3A%20%2360a5fa%3B%0A%20%20--remotion-studio-server-disconnected-background%3A%20%23e74c3c%3B%0A%20%20--remotion-studio-timeline-background-color%3A%20%2315181B%3B%0A%20%20--remotion-studio-timeline-negative-start-background-color%3A%20%232C2F32%3B%0A%20%20--remotion-studio-timeline-negative-start-border-color%3A%20%23414446%3B%0A%20%20--remotion-studio-timeline-selected-background-color%3A%20%233B3F42%3B%0A%20%20--remotion-studio-timeline-selected-label-background-color%3A%20%23B0B0B0%3B%0A%20%20--remotion-studio-timeline-blue%3A%20%230b84ff%3B%0A%20%20--remotion-studio-timeline-playhead-color%3A%20%23f02c00%3B%0A%20%20--remotion-studio-timeline-drop-blue-alpha-12%3A%20rgba(0%2C%20155%2C%20255%2C%200.12)%3B%0A%20%20--remotion-studio-timeline-drop-blue-alpha-16%3A%20rgba(0%2C%20155%2C%20255%2C%200.16)%3B%0A%20%20--remotion-studio-timeline-drop-blue-alpha-75%3A%20rgba(0%2C%20155%2C%20255%2C%200.75)%3B%0A%20%20--remotion-studio-timeline-marquee-blue-alpha-16%3A%20rgba(70%2C%20130%2C%20255%2C%200.16)%3B%0A%20%20--remotion-studio-timeline-marquee-blue-alpha-75%3A%20rgba(70%2C%20130%2C%20255%2C%200.75)%3B%0A%20%20--remotion-studio-easing-selected-background%3A%20rgba(11%2C%20132%2C%20243%2C%200.18)%3B%0A%20%20--remotion-studio-info-blue-background%3A%20rgba(59%2C%20130%2C%20246%2C%200.15)%3B%0A%20%20--remotion-studio-color-picker-checker-background-color%3A%20var(--remotion-studio-background)%3B%0A%20%20--remotion-studio-color-picker-hue-gradient%3A%20linear-gradient(to%20right%2C%20%23f00%200%25%2C%20%23ff0%2017%25%2C%20%230f0%2033%25%2C%20%230ff%2050%25%2C%20%2300f%2067%25%2C%20%23f0f%2083%25%2C%20%23f00%20100%25)%3B%0A%20%20--remotion-studio-timeline-audio-gradient%3A%20linear-gradient(rgb(16%20171%2058)%2C%20rgb(43%20165%2063)%2060%25)%3B%0A%20%20--remotion-studio-timeline-video-gradient%3A%20linear-gradient(to%20top%2C%20%238e44ad%2C%20%239b59b6)%3B%0A%20%20--remotion-studio-timeline-captions-gradient%3A%20linear-gradient(to%20top%2C%20%23b96516%2C%20%23cc7828)%3B%0A%20%20--remotion-studio-focus-color%3A%20%23555%3B%0A%20%20--remotion-studio-color-picker-checker-color%3A%20var(--remotion-studio-white-alpha-15)%3B%0A%20%20--remotion-studio-info-blue-border-color%3A%20rgba(59%2C%20130%2C%20246%2C%200.4)%3B%0A%20%20--remotion-studio-black-alpha-22%3A%20rgba(0%2C%200%2C%200%2C%200.22)%3B%0A%20%20--remotion-studio-font-family-error-color%3A%20%23ff8a8a%3B%0A%20%20--remotion-studio-selected-outline-snap-color%3A%20%23ff00ff%3B%0A%20%20--remotion-studio-prism-text-color%3A%20%23d4d4d4%3B%0A%20%20--remotion-studio-prism-selection-background%3A%20%23264f78%3B%0A%20%20--remotion-studio-prism-background%3A%20%231e1e1e%3B%0A%20%20--remotion-studio-prism-inline-color%3A%20%23db4c69%3B%0A%20%20--remotion-studio-prism-keyword-color%3A%20%23569cd6%3B%0A%20%20--remotion-studio-prism-variable-color%3A%20%239cdcfe%3B%0A%20%20--remotion-studio-prism-comment-color%3A%20%236a9955%3B%0A%20%20--remotion-studio-prism-number-color%3A%20%23b5cea8%3B%0A%20%20--remotion-studio-prism-string-color%3A%20%23ce9178%3B%0A%20%20--remotion-studio-prism-control-flow-color%3A%20%23c586c0%3B%0A%20%20--remotion-studio-prism-function-color%3A%20%23dcdcaa%3B%0A%20%20--remotion-studio-prism-regex-color%3A%20%23d16969%3B%0A%20%20--remotion-studio-prism-class-name-color%3A%20%234ec9b0%3B%0A%20%20--remotion-studio-prism-selector-color%3A%20%23d7ba7d%3B%0A%20%20--remotion-studio-prism-line-highlight-background%3A%20%23f7ebc6%3B%0A%20%20--remotion-studio-prism-line-highlight-border-color%3A%20%23f7d87c%3B%0A%7D%0A%3C%2Fstyle%3E%3Cg%20transform%3D%22rotate(90%2032%2032)%22%3E%3Cg%20transform%3D%22scale(0.876712329)%22%20filter%3D%22url(%23filter0_d_1_14)%22%3E%3Cpath%20d%3D%22M10.9111%2017.7687C10.3413%2018.3701%2010.367%2019.3195%2010.9684%2019.8893L20.7687%2029.1738C21.3701%2029.7436%2022.3195%2029.7179%2022.8893%2029.1165C23.459%2028.5151%2023.4334%2027.5657%2022.832%2026.996L14.1206%2018.7431L22.3735%2010.0316C22.9432%209.43022%2022.9176%208.48082%2022.3162%207.91107C21.7148%207.34133%2020.7654%207.36699%2020.1956%207.96839L10.9111%2017.7687ZM49.3923%2058.3118C49.9509%2058.9235%2050.8996%2058.9667%2051.5114%2058.4081L61.481%2049.3055C62.0927%2048.7469%2062.1359%2047.7981%2061.5773%2047.1863C61.0187%2046.5745%2060.0699%2046.5314%2059.4581%2047.09L50.5963%2055.1812L42.5051%2046.3194C41.9465%2045.7076%2040.9977%2045.6645%2040.386%2046.2231C39.7742%2046.7817%2039.7311%2047.7304%2040.2896%2048.3422L49.3923%2058.3118ZM12.6747%2018.7431L13%2019.8893C22.1283%2019.6426%2030.7584%2021.4283%2037.8564%2026.6927C44.8518%2031.8809%2049.734%2039.8538%2049%2056H50.5963H51.5114C52.2774%2039.1461%2047.6482%2030.2198%2039.6436%2024.2831C31.7416%2018.4224%2022.3717%2017.2467%2013%2017.5L12.6747%2018.7431Z%22%20fill%3D%22var(--remotion-studio-black)%22%2F%3E%3Cpath%20d%3D%22M19.1064%206.93652C20.2459%205.73379%2022.1448%205.68278%2023.3477%206.82227C24.5505%207.96181%2024.6022%209.86076%2023.4629%2011.0635L18.7373%2016.0508C26.3487%2016.4239%2033.9128%2018.1651%2040.5371%2023.0781C44.7339%2026.1907%2048.0794%2030.1189%2050.2568%2035.4834C51.9666%2039.6958%2052.9327%2044.7395%2053.0742%2050.8867L58.4463%2045.9824C59.6697%2044.8654%2061.5673%2044.9514%2062.6846%2046.1748C63.8018%2047.3985%2063.7155%2049.296%2062.4922%2050.4131L52.5225%2059.5156C51.337%2060.5979%2049.5196%2060.5507%2048.3916%2059.4346L48.2842%2059.3232L39.1816%2049.3535C38.0648%2048.1301%2038.1507%2046.2324%2039.374%2045.1152C40.5975%2043.9979%2042.4961%2044.0841%2043.6133%2045.3076L47.4756%2049.5381C47.1908%2044.7613%2046.2876%2040.9448%2044.9482%2037.8291C43.0666%2033.4521%2040.2851%2030.3614%2036.9629%2027.8975C31.8259%2024.0875%2025.8071%2022.1663%2019.2891%2021.5732L23.8633%2025.9072C25.0662%2027.0468%2025.1178%2028.9457%2023.9785%2030.1484C22.8746%2031.3135%2021.0576%2031.3982%2019.8516%2030.3662L19.7373%2030.2627L9.93652%2020.9785C8.73384%2019.839%208.6828%2017.9401%209.82227%2016.7373L19.1064%206.93652Z%22%20stroke%3D%22var(--remotion-studio-white)%22%20stroke-width%3D%223%22%2F%3E%3C%2Fg%3E%3C%2Fg%3E%3Cdefs%3E%3Cfilter%20id%3D%22filter0_d_1_14%22%20x%3D%220%22%20y%3D%220%22%20width%3D%2272.4696%22%20height%3D%2272.3004%22%20filterUnits%3D%22userSpaceOnUse%22%20color-interpolation-filters%3D%22sRGB%22%3E%3CfeFlood%20flood-opacity%3D%220%22%20result%3D%22BackgroundImageFix%22%2F%3E%3CfeColorMatrix%20in%3D%22SourceAlpha%22%20type%3D%22matrix%22%20values%3D%220%200%200%200%200%200%200%200%200%200%200%200%200%200%200%200%200%200%20127%200%22%20result%3D%22hardAlpha%22%2F%3E%3CfeOffset%20dy%3D%223%22%2F%3E%3CfeGaussianBlur%20stdDeviation%3D%223.75%22%2F%3E%3CfeComposite%20in2%3D%22hardAlpha%22%20operator%3D%22out%22%2F%3E%3CfeColorMatrix%20type%3D%22matrix%22%20values%3D%220%200%200%200%200%200%200%200%200%200%200%200%200%200%200%200%200%200%200.25%200%22%2F%3E%3CfeBlend%20mode%3D%22normal%22%20in2%3D%22BackgroundImageFix%22%20result%3D%22effect1_dropShadow_1_14%22%2F%3E%3CfeBlend%20mode%3D%22normal%22%20in%3D%22SourceGraphic%22%20in2%3D%22effect1_dropShadow_1_14%22%20result%3D%22shape%22%2F%3E%3C%2Ffilter%3E%3C%2Fdefs%3E%3C%2Fsvg%3E") 12 12, alias'
				}
				style={{
					position: 'absolute',
					left: 0,
					top: 0,
					scale: interpolate(
						frame,
						[0, 87, 95, 405, 411],
						[
							5.341989334569905, 4.807790401112914, 5.341989334569905,
							4.807790401112914, 5.341989334569905,
						],
						{
							easing: Easing.step1,
							extrapolateLeft: 'clamp',
							extrapolateRight: 'clamp',
						},
					),
					translate: interpolate(
						frame,
						[
							6, 7, 8, 9, 10, 11, 12, 13, 14, 15, 16, 17, 18, 19, 20, 21, 22,
							23, 24, 25, 26, 27, 28, 29, 30, 31, 32, 33, 34, 35, 36, 37, 38,
							39, 40, 41, 42, 43, 44, 45, 46, 47, 48, 49, 50, 51, 52, 53, 54,
							55, 56, 57, 58, 59, 60, 61, 62, 63, 64, 65, 66, 67, 68, 69, 70,
							71, 72, 73, 74, 75, 76, 77, 78, 79, 106, 107, 108, 109, 110, 111,
							112, 113, 114, 115, 116, 117, 118, 119, 120, 121, 122, 123, 124,
							125, 126, 127, 128, 129, 130, 131, 132, 133, 134, 135, 136, 137,
							138, 139, 140, 141, 142, 143, 144, 145, 146, 147, 148, 149, 150,
							151, 152, 153, 154, 155, 156, 157, 158, 159, 160, 161, 162, 163,
							164, 165, 166, 167, 168, 169, 170, 171, 172, 173, 174, 175, 176,
							177, 178, 179, 180, 181, 182, 183, 184, 185, 186, 187, 188, 189,
							190, 191, 192, 193, 194, 195, 196, 197, 198, 199, 200, 201, 202,
							203, 204, 205, 206, 207, 208, 209, 210, 211, 212, 213, 214, 215,
							216, 217, 218, 219, 220, 221, 222, 223, 224, 225, 226, 227, 228,
							229, 230, 231, 232, 233, 234, 235, 236, 237, 238, 239, 240, 241,
							242, 243, 244, 245, 246, 247, 248, 249, 250, 251, 252, 253, 254,
							255, 256, 257, 258, 259, 260, 261, 262, 263, 264, 265, 266, 278,
							279, 280, 288, 289, 290, 291, 292, 293, 294, 295, 296, 297, 298,
							299, 300, 335, 336, 337, 338, 339, 340, 341, 342, 343, 344, 345,
							346, 347, 348, 349, 350, 351, 352, 353, 354, 355, 356, 357, 358,
							359, 360, 361, 362, 363, 364, 365, 366, 367, 368, 369, 370, 371,
							372, 373, 374, 375, 376, 377, 378, 379, 380, 381, 382, 383, 384,
							385, 386, 387, 388, 389, 390, 391, 392, 393, 394, 395, 396, 397,
							400, 401, 409, 410, 411,
						],
						[
							'3419.8121956874566px 6200.380245768607px',
							'3418.643635520519px 6200.380245768607px',
							'3418.2888940412704px 6200.380245768607px',
							'3417.1203338743335px 6199.858567122653px',
							'3417.1203338743335px 6199.858567122653px',
							'3403.2019476002783px 6158.458149779735px',
							'3387.739392534199px 6059.31833990262px',
							'3338.993739856249px 5770.162300023186px',
							'3263.9554834222117px 5358.453512636216px',
							'3245.0498492928355px 4987.519128217018px',
							'3229.691629955947px 4834.31254347322px',
							'3194.9269649895664px 4651.891954555994px',
							'3194.9269649895664px 4651.891954555994px',
							'2901.075817296545px 3943.827961975423px',
							'2465.2237421748205px 3180.2573614653375px',
							'2282.3023417574773px 2886.614885230698px',
							'2068.7688383955483px 2588.1312311616043px',
							'1937.9527011361001px 2411.4908416415487px',
							'1734.2476234639462px 2119.7681428240203px',
							'1651.9684674240668px 2004.3728263389753px',
							'1604.8504521214932px 1938.328309761187px',
							'1597.4634824947832px 1923.8673776953397px',
							'1588.3654069093438px 1900.1205657315095px',
							'1574.593090656156px 1874.6626478089497px',
							'1539.807558543937px 1833.0952932993275px',
							'1460.387201483886px 1749.897982842569px',
							'1381.8849988407142px 1681.808485972641px',
							'1300.1275214467887px 1626.0723394389056px',
							'1202.4692789241826px 1558.3375840482263px',
							'1080.375608625087px 1452.4368189195457px',
							'1006.1511708787388px 1356.3018780431255px',
							'977.3545096220728px 1281.0966844423835px',
							'974.6626478089497px 1228.0732668676096px',
							'978.2309297472757px 1104.20588917227px',
							'981.59054022722px 1020.215627173661px',
							'981.5070716438673px 915.6086250869464px',
							'976.4154880593554px 853.8210062601438px',
							'965.0011592858799px 817.8460468351495px',
							'948.7665198237886px 780.2851843264549px',
							'930.2573614653373px 750.2364943194992px',
							'901.1059587294227px 713.6563876651983px',
							'836.3134709019245px 647.4031996290286px',
							'611.9916531416648px 459.70322281474614px',
							'487.5399953628565px 364.0482262926038px',
							'402.48550892650127px 303.8256434036633px',
							'342.09598887085554px 263.0929747275678px',
							'339.4249942035706px 261.17319731045677px',
							'334.8759564108509px 257.8344539763506px',
							'334.7090192441456px 257.1875724553675px',
							'333.79086482726643px 254.85045212149316px',
							'330.8485972640853px 247.73475539067934px',
							'307.7904011129144px 215.55761650823092px',
							'275.94713656387665px 189.34848133549733px',
							'233.19035474147924px 162.72200324600047px',
							'205.24924646417807px 146.15348945049848px',
							'196.27637375376767px 140.58196151170878px',
							'193.9183862740552px 138.6830512404359px',
							'193.77231625318805px 138.28657546951078px',
							'192.95849756549964px 136.47113378159054px',
							'191.2682587526084px 133.09065615580803px',
							'189.51541850220264px 127.10178530025505px',
							'189.09807558543937px 122.11453744493392px',
							'189.09807558543937px 115.62485508926501px',
							'189.11894273127754px 111.4931602133086px',
							'189.66148852306978px 107.5284025040575px',
							'190.24576860653838px 103.1045675863668px',
							'190.93438441919778px 100.47530721075817px',
							'192.37421748203107px 97.13656387665198px',
							'194.06445629492234px 94.61163923023418px',
							'195.0034778576397px 93.48481335497334px',
							'196.63111523301646px 92.33712033387434px',
							'197.02759100394158px 92.02411314630189px',
							'197.57013679573382px 91.48156735450962px',
							'197.94574542082077px 91.48156735450962px',
							'197.94574542082077px 91.48156735450962px',
							'198.38395548342223px 91.48156735450962px',
							'203.14166473452354px 91.10595872942268px',
							'211.5511245073035px 90.56341293763042px',
							'221.42128448875494px 90.04173429167633px',
							'232.5852075121725px 89.16531416647345px',
							'243.5613262230466px 88.30976118710875px',
							'257.62578251796896px 88.26802689543241px',
							'260.15070716438674px 88.05935543705078px',
							'263.69812195687456px 87.97588685369813px',
							'266.6612566658938px 87.62114537444934px',
							'272.3579874797125px 87.22466960352423px',
							'278.4303269186181px 86.53605379086483px',
							'292.57825179689314px 85.53443079063297px',
							'307.0391838627406px 84.61627637375376px',
							'317.4727567818224px 84.51194064456296px',
							'327.15511245073037px 84.51194064456296px',
							'337.0878738696963px 84.51194064456296px',
							'347.98052399721774px 84.67887781126826px',
							'352.5295617899374px 85.03361929051704px',
							'354.67887781126825px 85.03361929051704px',
							'357.0577324368189px 85.03361929051704px',
							'360.6468815209831px 85.03361929051704px',
							'364.84117783445396px 85.03361929051704px',
							'368.284256897751px 85.03361929051704px',
							'370.9969858567123px 85.03361929051704px',
							'374.73220496174355px 84.97101785300255px',
							'380.19939717134247px 84.3658706236958px',
							'385.5205193600742px 84.3658706236958px',
							'391.1755158822166px 84.3658706236958px',
							'395.20287502898213px 84.3658706236958px',
							'397.9364711337816px 84.3658706236958px',
							'400.79527011361px 84.3658706236958px',
							'407.8900996985857px 84.3658706236958px',
							'416.5916995130999px 84.3658706236958px',
							'420.5773243681892px 84.3658706236958px',
							'426.00278228611177px 84.3658706236958px',
							'429.0285184326455px 84.3658706236958px',
							'441.59054022722006px 84.3658706236958px',
							'447.80894968699283px 84.3658706236958px',
							'456.71922095988873px 83.7398562485509px',
							'462.4785532112219px 83.53118479016926px',
							'469.6985856712265px 83.53118479016926px',
							'478.5671226524461px 83.53118479016926px',
							'489.8771156967308px 83.53118479016926px',
							'496.24159517737075px 83.36424762346395px',
							'503.5242290748899px 83.03037329005333px',
							'515.022026431718px 82.57129608161372px',
							'520.9900301414328px 82.19568745652678px',
							'526.102480871783px 82.19568745652678px',
							'532.091351727336px 82.19568745652678px',
							'540.125202875029px 82.19568745652678px',
							'549.7449571064225px 82.19568745652678px',
							'556.2137723162532px 82.15395316485045px',
							'565.1449107349872px 81.46533735219106px',
							'570.9251101321586px 81.46533735219106px',
							'574.4099234871319px 81.46533735219106px',
							'579.2511013215859px 81.46533735219106px',
							'586.0746580106654px 81.46533735219106px',
							'590.1020171574311px 81.46533735219106px',
							'596.0491537213077px 81.46533735219106px',
							'602.3718989102713px 81.46533735219106px',
							'608.0060282865754px 81.46533735219106px',
							'617.0206352886622px 81.46533735219106px',
							'625.4300950614421px 81.46533735219106px',
							'633.4013447716206px 81.6114073730582px',
							'639.8492928356133px 81.88268026895433px',
							'648.8638998376999px 81.88268026895433px',
							'657.9619754231394px 82.4669603524229px',
							'665.9958265708324px 83.17644331092048px',
							'674.1548805935544px 83.17644331092048px',
							'683.1068861581266px 83.2807790401113px',
							'683.1068861581266px 83.2807790401113px',
							'696.8792024113146px 83.84419197774172px',
							'704.3705077672154px 84.32413633201948px',
							'711.0479944354278px 84.61627637375376px',
							'719.353118479017px 84.92928356132623px',
							'726.3436123348017px 84.92928356132623px',
							'734.7322049617436px 85.61789937398562px',
							'740.1785300255043px 85.70136795733828px',
							'748.9009969858568px 86.41085091583585px',
							'754.7437978205426px 86.47345235335034px',
							'760.670067238581px 86.93252956178993px',
							'766.9719452817064px 86.93252956178993px',
							'772.7521446788778px 86.93252956178993px',
							'783.7073962439138px 87.53767679109669px',
							'790.7813586830513px 87.68374681196383px',
							'799.5038256434036px 87.68374681196383px',
							'803.3851147693022px 87.95501970785996px',
							'811.1894273127754px 87.97588685369813px',
							'814.9246464178067px 88.05935543705078px',
							'822.0820774402968px 88.51843264549038px',
							'836.0213308601901px 88.51843264549038px',
							'849.5432413633202px 88.99837699976814px',
							'861.9383259911895px 89.7704613957802px',
							'870.0973800139114px 90.02086714583817px',
							'878.5277069325296px 90.02086714583817px',
							'888.2100626014375px 90.6886158126594px',
							'896.0352422907489px 90.79295154185021px',
							'901.2311616044517px 91.16856016693717px',
							'904.7368421052631px 91.16856016693717px',
							'917.5701367957338px 91.8989102712729px',
							'925.2492464641781px 91.8989102712729px',
							'934.2429863204267px 91.8989102712729px',
							'938.9589612798516px 92.19105031300718px',
							'946.8884766983538px 92.92140041734292px',
							'955.1101321585903px 93.65175052167865px',
							'965.9610479944355px 94.56990493855785px',
							'974.2244377463483px 95.27938789705541px',
							'983.614653373522px 96.05147229306748px',
							'991.0642244377464px 96.40621377231625px',
							'998.534662647809px 96.40621377231625px',
							'1004.6070020867146px 96.7818223974032px',
							'1011.2427544632507px 97.38696962670994px',
							'1018.5253883607697px 97.59564108509159px',
							'1024.9524692789241px 97.67910966844424px',
							'1031.7134245304892px 98.32599118942731px',
							'1036.658938094134px 98.80593554370508px',
							'1040.7697658242523px 98.93113841873406px',
							'1043.023417574774px 99.20241131463018px',
							'1045.9865522837931px 99.5362856480408px',
							'1049.0331555761652px 99.80755854393693px',
							'1052.8935775562254px 100.2875028982147px',
							'1056.8166009738002px 100.35010433572918px',
							'1060.9274287039184px 100.87178298168328px',
							'1067.0832367261767px 101.01785300255042px',
							'1072.6338975191281px 101.4977973568282px',
							'1080.4799443542777px 101.70646881520983px',
							'1087.0948295849757px 102.10294458613494px',
							'1097.215395316485px 103.14630187804313px',
							'1105.0614421516345px 103.6262462323209px',
							'1114.66032923719px 104.14792487827498px',
							'1121.942963134709px 104.83654069093438px',
							'1128.0987711569674px 105.35821933688848px',
							'1138.0315325759332px 105.50428935775562px',
							'1145.00115928588px 105.96336656619522px',
							'1157.124971017853px 105.96336656619522px',
							'1164.7414792487828px 106.10943658706238px',
							'1172.3371203338743px 106.33897519128217px',
							'1185.6086250869464px 106.33897519128217px',
							'1203.6169719452816px 106.33897519128217px',
							'1226.4456294922327px 107.34059819151403px',
							'1241.8038488291213px 107.34059819151403px',
							'1259.2070484581498px 107.34059819151403px',
							'1277.6536053790865px 107.50753535821934px',
							'1298.9798284256897px 108.53002550428936px',
							'1320.3477857639693px 109.05170415024345px',
							'1335.5808022258288px 109.4899142128449px',
							'1346.9116624159517px 109.80292140041735px',
							'1360.558775794111px 109.80292140041735px',
							'1369.5942499420357px 109.80292140041735px',
							'1378.6297240899605px 110.44980292140042px',
							'1383.2204961743566px 110.44980292140042px',
							'1386.3923023417574px 110.5750057964294px',
							'1391.2126130303734px 111.034083004869px',
							'1394.1548805935545px 111.034083004869px',
							'1396.0120565731509px 111.034083004869px',
							'1396.9302109900302px 111.034083004869px',
							'1398.5995826570831px 111.034083004869px',
							'1399.8516114073732px 111.034083004869px',
							'1401.625318803617px 111.034083004869px',
							'1401.625318803617px 111.034083004869px',
							'1402.146997449571px 111.034083004869px',
							'1402.397403199629px 111.034083004869px',
							'1402.397403199629px 111.034083004869px',
							'1402.9399489914213px 111.034083004869px',
							'1403.1694875956412px 111.034083004869px',
							'1404.4841177834453px 111.68096452585208px',
							'1404.4841177834453px 111.8896359842337px',
							'1405.1309993044285px 113.20426617203803px',
							'1405.1936007419429px 113.20426617203803px',
							'1405.5066079295154px 113.20426617203803px',
							'1406.341293763042px 113.20426617203803px',
							'1407.113378159054px 113.20426617203803px',
							'1407.113378159054px 113.20426617203803px',
							'1407.113378159054px 111.57662879666125px',
							'1407.113378159054px 110.82541154648736px',
							'1407.113378159054px 110.82541154648736px',
							'1407.8645954092278px 110.82541154648736px',
							'1441.0850915835845px 110.82541154648736px',
							'1538.4303269186182px 111.01321585903084px',
							'1678.3028054718293px 114.28935775562253px',
							'1837.873869696267px 120.04869000695571px',
							'2005.4579179225598px 131.77602596800372px',
							'2175.817296545328px 147.86459540922792px',
							'2284.2638534662647px 161.88731741247392px',
							'2436.1558080222585px 185.78019939717134px',
							'2603.4685833526546px 213.26223046603292px',
							'2843.8998376999766px 255.6225365175052px',
							'3024.3380477625783px 292.72432181776026px',
							'3158.0964525852073px 331.4328773475539px',
							'3329.081845583121px 381.24275446325066px',
							'3431.998608856944px 421.2033387433341px',
							'3529.8237885462554px 470.84627869232554px',
							'3627.8367725481103px 537.329005332715px',
							'3769.5246927892417px 649.5942499420357px',
							'3863.489450498493px 738.3213540459077px',
							'4008.453512636216px 956.1743565963367px',
							'4124.787850683979px 1366.0259680037097px',
							'4171.425921632274px 1824.2476234639462px',
							'4176.308833758405px 2572.8356132622307px',
							'4116.837468119638px 3211.70415024345px',
							'4021.5998145142594px 3951.047994435428px',
							'3966.239276605611px 4354.305587757941px',
							'3897.5654996522144px 4696.6728495246925px',
							'3862.1956874565267px 4851.277533039648px',
							'3825.657315093902px 4971.180153025736px',
							'3807.523765360538px 5027.95965685138px',
							'3783.443079063297px 5087.4310224901465px',
							'3769.6081613725946px 5113.9114305587755px',
							'3765.351263621609px 5117.855321122189px',
							'3751.850220264317px 5130.521678645954px',
							'3734.6556920936705px 5156.3552051936px',
							'3703.897519128217px 5216.056109436587px',
							'3669.5710642244376px 5274.567586366798px',
							'3580.4474843496405px 5424.560630651518px',
							'3493.0767447252492px 5626.116392302341px',
							'3409.649895664271px 5887.0183167169025px',
							'3374.6765592395086px 6003.561326223046px',
							'3354.247623463946px 6056.083932297704px',
							'3324.240667748667px 6130.537908648273px',
							'3294.671922095989px 6198.690006955715px',
							'3265.478785068398px 6260.581961511709px',
							'3258.1961511708787px 6275.314166473452px',
							'3256.6311152330163px 6278.402504057501px',
							'3252.9376304196617px 6286.498956642708px',
							'3246.5940180848597px 6301.126825875261px',
							'3246.4896823556687px 6302.003246000464px',
							'3246.4896823556687px 6302.003246000464px',
							'3246.4896823556687px 6302.670994667285px',
							'3246.8235566890794px 6303.964757709251px',
							'3247.0322281474614px 6304.382100626014px',
							'3247.220032460005px 6304.382100626014px',
							'3260.178530025504px 6302.378854625551px',
							'3286.0955251565038px 6299.749594249942px',
							'3340.433572919082px 6294.616276373754px',
							'3378.4743797820543px 6291.340134477162px',
							'3378.4743797820543px 6291.340134477162px',
							'3452.8031532575933px 6282.555066079295px',
							'3455.3698121956877px 6282.283793183399px',
							'3455.3698121956877px 6282.283793183399px',
							'3455.8914908416414px 6282.283793183399px',
							'3455.8914908416414px 6282.283793183399px',
							'3458.249478321354px 6283.848829121262px',
							'3458.3538140505448px 6283.953164850453px',
						],
						{
							extrapolateLeft: 'clamp',
							extrapolateRight: 'clamp',
						},
					),
				}}
			/>
		</AbsoluteFill>
	);
};
